import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';

const usePMS = () => {
  const clinicId = loadSelectedClinicId();
  const { data, error, mutate } = useSWR(
    ['/pms/download-link', clinicId],
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<{ link: string }>(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default usePMS;
